<input
  type="color"
  class="form-control form-control-sm color-swatch"
  [ngClass]="cssClass"
  [value]="value"
  (input)="inputEvent.emit($event)"
  (change)="changeEvent.emit($event)"
/>
